import React, { useEffect, useState } from 'react';
import { Share2, Download } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from './ui/card';
import { Badge } from './ui/badge';
import { clientPortalAPI } from '../lib/api';

const fmtSize = (b) => (!b ? '' : b < 1024 * 1024 ? `${Math.max(1, Math.round(b / 1024))} KB` : `${(b / (1024 * 1024)).toFixed(1)} MB`);

export default function ClientPlanFiles() {
  const [files, setFiles] = useState(null);
  useEffect(() => { clientPortalAPI.getPlanFiles().then(setFiles).catch(() => setFiles([])); }, []);
  if (!files) return null;

  return (
    <Card data-testid="client-plan-files">
      <CardHeader>
        <CardTitle className="flex items-center gap-2 text-lg"><Share2 className="w-5 h-5 text-primary" />Plan de Social Media</CardTitle>
        <CardDescription>Tu plan de redes. Aquí tienes siempre el vigente y los anteriores.</CardDescription>
      </CardHeader>
      <CardContent className="space-y-2">
        {files.length === 0 ? (
          <p className="text-sm text-muted-foreground" data-testid="client-plan-files-empty">Todavía no hemos subido tu plan.</p>
        ) : files.map((f, i) => (
          <a key={f.id} href={clientPortalAPI.planFileUrl(f.id)} target="_blank" rel="noopener noreferrer"
            className={`flex items-center justify-between gap-3 p-3 rounded-lg border hover:bg-muted transition-colors ${i === 0 ? 'border-emerald-300' : ''}`}
            data-testid={`client-plan-file-${f.id}`}>
            <div className="min-w-0">
              <p className="font-medium text-sm truncate">
                {f.nombre}
                {i === 0 && <Badge className="ml-2 bg-emerald-100 text-emerald-700">Plan vigente</Badge>}
              </p>
              <p className="text-xs text-muted-foreground">
                Subido el {f.fecha ? new Date(f.fecha).toLocaleDateString('es-ES', { day: 'numeric', month: 'long', year: 'numeric' }) : '—'} {fmtSize(f.tamano) && `· ${fmtSize(f.tamano)}`}
              </p>
            </div>
            <Download className="w-4 h-4 text-primary shrink-0" />
          </a>
        ))}
      </CardContent>
    </Card>
  );
}
